// extracted by mini-css-extract-plugin
module.exports = {"profile":"Navigation_profile__3r5Kq","nav":"Navigation_nav__4IL2A","dropdown":"Navigation_dropdown__38ItA","divider":"Navigation_divider__q9hye"};